/* Theme - ATC Animation + CRO Enhancements */
(function () {

  /* ============================================================
     1. ADD TO CART ANIMATION
     ============================================================ */
  function initATCAnimation() {
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(attachToForm);
    new MutationObserver(() => {
      document.querySelectorAll('[data-type="add-to-cart-form"]:not([data-dz-bound])').forEach(attachToForm);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function attachToForm(form) {
    if (form.dataset.dzBound) return;
    form.dataset.dzBound = 'true';
    const btn = form.querySelector('.product-form__submit');
    if (!btn) return;

    form.addEventListener('submit', function () {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      // Ripple
      const ripple = document.createElement('span');
      ripple.classList.add('dz-ripple-el');
      ripple.style.top = '50%';
      ripple.style.left = '50%';
      btn.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);

      // Pop
      btn.classList.remove('dz-atc-animate');
      void btn.offsetWidth;
      btn.classList.add('dz-atc-animate');

      // Success flash
      const label = btn.querySelector('span:not(.visually-hidden)');
      const originalLabel = label ? label.textContent : '';
      setTimeout(() => {
        btn.classList.add('dz-atc-success');
        if (label) label.textContent = '\u2713 Added!';
        setTimeout(() => {
          btn.classList.remove('dz-atc-success', 'dz-atc-animate');
          if (label) label.textContent = originalLabel;
        }, 1600);
      }, 300);
    });
  }

  /* ============================================================
     3. STICKY MOBILE ATC BAR
     Appears when the main ATC button scrolls off screen
     ============================================================ */
  function initStickyATC() {
    if (window.innerWidth > 749) return;
    const mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn || document.getElementById('dz-sticky-atc')) return;

    const rawTitle = document.querySelector('.product__title h1, .product__title h2')?.textContent?.trim() || '';
    const title = rawTitle.length > 28 ? rawTitle.slice(0, 28) + '\u2026' : rawTitle;
    const price = document.querySelector('.price__regular .price-item, .price-item--regular')?.textContent?.trim() || '';

    const bar = document.createElement('div');
    bar.id = 'dz-sticky-atc';
    bar.innerHTML = `
      <div class="dz-sticky-atc__inner">
        <div class="dz-sticky-atc__info">
          <span class="dz-sticky-atc__name">${title}</span>
          <span class="dz-sticky-atc__price">${price}</span>
        </div>
        <button class="dz-sticky-atc__btn" type="button">Add to Cart</button>
      </div>
    `;
    document.body.appendChild(bar);

    bar.querySelector('.dz-sticky-atc__btn').addEventListener('click', () => {
      mainBtn.click();
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('dz-sticky-atc--show', !entry.isIntersecting),
      { rootMargin: '0px 0px -10px 0px' }
    ).observe(mainBtn);
  }

  /* ============================================================
     4. LOW STOCK URGENCY STYLING
     ============================================================ */
  function styleInventory() {
    const inv = document.querySelector('.product__inventory');
    if (!inv) return;
    const text = inv.textContent.toLowerCase();
    if (text.includes('low stock') || /\b[1-5]\s+(left|remaining|in stock)/i.test(text)) {
      inv.classList.add('dz-inv-urgent');
    }
  }

  /* ============================================================
     5. SALE BADGE UPGRADE
     ============================================================ */
  function upgradeSaleBadges() {
    document.querySelectorAll('.badge--sale, .badge--on-sale').forEach(b => b.classList.add('dz-sale-badge'));
  }

  /* ============================================================
     6. COLLECTION PAGE - SELLING FAST BADGES
     Adds a subtle badge to products marked with a 'selling-fast' tag
     ============================================================ */
  function injectSellingFastBadges() {
    document.querySelectorAll('[data-product-id]').forEach(card => {
      const tags = card.dataset.productTags || '';
      if (tags.includes('selling-fast') || tags.includes('bestseller')) {
        const media = card.querySelector('.card__media, .card-product__image');
        if (media && !media.querySelector('.dz-selling-fast')) {
          const badge = document.createElement('div');
          badge.className = 'dz-selling-fast';
          badge.textContent = '\uD83D\uDD25 Selling Fast';
          media.appendChild(badge);
        }
      }
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initATCAnimation();
    initStickyATC();
    styleInventory();
    upgradeSaleBadges();
    injectSellingFastBadges();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
